import React, {useState} from 'react'
import css from '../LoginV2Layout.module.scss'
import LoginV2Layout from '../LoginV2Layout'
import PasswordRecoveryForm from './containers/PasswordRecoveryForm'
import LoginForm from './containers/LoginForm'

const LoginV2 = ({logo, supportEmail}) => {
  const [recoverPasswordForm, setRecoverPasswordForm] = useState(false)

  return (
    <LoginV2Layout logo={logo}>
      <div className={css.formContainer}>
        {!recoverPasswordForm ?
          <div className={css.welcomeSection}>
            <h1 className={css.welcomeTitle}>Welcome back!</h1>
            <p className={css.welcomeSubtitle}>Your next opportunity awaits.</p>
          </div>
        :
          <div className={css.welcomeSection}>
            <h1 className={css.welcomeTitle}>Password reset</h1>
            <p className={css.welcomeSubtitle}>Enter your email address or username and we'll send you instructions to reset your password</p>
          </div>
        }
        <div className={css.loginForm}>
          {recoverPasswordForm ? <PasswordRecoveryForm/> : <LoginForm supportEmail={supportEmail}/>}
        </div>
      </div>
      <div>
        {recoverPasswordForm ?
          <p onClick={() => setRecoverPasswordForm(false)}
             className={css.passwordRecovery}>
            Back to login
          </p>
          :
          <p onClick={() => setRecoverPasswordForm(true)}
             className={css.passwordRecovery}>
            Forgot your password?
          </p>
        }
      </div>
    </LoginV2Layout>
  )
}

export default LoginV2
